var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreatWallGrid = function SvgGreatWallGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.158 1.248h16v16h-16zM23.158 1.248h16v16h-16zM1.158 23.248h16v16h-16zM23.158 23.248h16v16h-16z"
  })));
};
export default SvgGreatWallGrid;